import { Component, Input } from '@angular/core';
import { FnolRequest } from "../../../models";

@Component({
  selector: 'CPF-classification-check-preview',
  templateUrl: './classification-check-preview.component.html',
  styleUrls: ['./classification-check-preview.component.scss']
})
export class ClassificationCheckPreviewComponent {
  _fnolRequest?: FnolRequest;

  availableChecks = {
    medicalFood: false,
    complementaryMedicine: false,
    behavioralTreatment: false,
  }

  checksPerformed: {
    medicalFoodPrescription?: boolean,
    complementaryMedicinePrescription?: boolean,
    complementaryMedicineTherapist?: boolean,
    behavioralTreatmentTherapist?: boolean,
  } = {
    medicalFoodPrescription: undefined,
    complementaryMedicinePrescription: undefined,
    complementaryMedicineTherapist: undefined,
    behavioralTreatmentTherapist: undefined,
  }

  expanded = false;

  @Input() set fnolRequest(value: FnolRequest) {
    this._fnolRequest = value;

    this._fnolRequest.parsedInvoiceData.treatments.forEach(t => t.positions.forEach(p => {
      if (p.classification && p.classification.subtype === 'medizinalfutter') {
        this.availableChecks.medicalFood = true;
      }

      if (p.classification && p.classification.subtype === 'komplementaermedizinische_behandlung') {
        this.availableChecks.complementaryMedicine = true;
      }

      if (p.classification && p.classification.subtype === 'verhaltensmedizinische_behandlung') {
        this.availableChecks.behavioralTreatment = true;
      }

      if (p.classification && p.classification.checks && p.classification.checks.medicalFoodPrescription !== undefined) {
        this.checksPerformed.medicalFoodPrescription = p.classification.checks.medicalFoodPrescription;
      }

      if (p.classification && p.classification.checks && p.classification.checks.complementaryMedicinePrescription !== undefined) {
        this.checksPerformed.complementaryMedicinePrescription = p.classification.checks.complementaryMedicinePrescription;
      }

      if (p.classification && p.classification.checks && p.classification.checks.complementaryMedicineTherapist !== undefined) {
        this.checksPerformed.complementaryMedicineTherapist = p.classification.checks.complementaryMedicineTherapist;
      }

      if (p.classification && p.classification.checks && p.classification.checks.behavioralTreatmentTherapist !== undefined) {
        this.checksPerformed.behavioralTreatmentTherapist = p.classification.checks.behavioralTreatmentTherapist;
      }
    }))
  }
}
